import { rem } from '../../../utils/rem';
import { tundora } from '../colors';
export var MuiPopper = {
    styleOverrides: {
        root: {
            border: "".concat(rem(1), " solid ").concat(tundora),
        },
    },
};
